import script from "./queryPrice.vue?vue&type=script&setup=true&lang=js"
export * from "./queryPrice.vue?vue&type=script&setup=true&lang=js"

import "./queryPrice.vue?vue&type=style&index=0&id=1e23bdba&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e23bdba"]])

export default __exports__